import React, { useEffect, useRef } from 'react'
import ProvidedService from '../components/ProvidedService'
import gsap from 'gsap';
// import gsap from 'gsap';



const ServicesCards = [
    { id: 1, title: "Web and Software Development", description: "We design and build scalable, high-performance web applications and custom enterprise software using modern frameworks like Laravel, Node.js, React, and Vue.js." },
    { id: 2, title: "Mobile Application Development", description: "We develop mobile applications for Android, iOS, and cross-platform environments using Flutter and React Native, ensuring a seamless user experience and reliable performance." },
    { id: 3, title: "eCommerce Solutions", description: "From custom-built stores to platforms like Shopify and WooCommerce, we develop secure, fast, and conversion-optimized eCommerce systems with intuitive dashboards and integrated payment gateways." },
    { id: 4, title: "AI-Powered Chatbots", description: "We build intelligent chatbots that handle customer queries, automate lead generation, and assist internal workflows across platforms such as websites, WhatsApp, and support portals." },
    { id: 5, title: "LLM-Based Automation", description: "We develop solutions using Large Language Models to automate content generation, customer interaction, internal documentation, smart search, and knowledge retrieval." },
    { id: 6, title: "UI/UX Design", description: "Our design team creates intuitive and aesthetically refined interfaces backed by usability principles, wireframes, and interactive prototypes to ensure meaningful digital experiences." },
    { id: 7, title: "Quality Assurance and Testing", description: "We provide manual and automated testing across platforms to ensure that all applications meet reliability, security, and usability standards before and after deployment." },
    { id: 8, title: "Cloud and DevOps Services", description: "We manage cloud deployments and infrastructure using AWS, Azure, and GCP, along with CI/CD pipelines, containerization (Docker), and infrastructure-as-code for streamlined operations." },
    { id: 9, title: "SEO and Digital Strategy", description: "We help businesses grow through effective SEO strategies, content optimization, analytics integration, and performance monitoring to improve visibility and generate leads." },
    { id: 10, title: "Technology Consulting", description: "We offer consulting services to guide digital transformation, technology modernization, software architecture decisions, and system integrations, helping you stay competitive in a digital-first world." },
]

const ProvidedServices = () => {
    const cardsRef = useRef([]);

    useEffect(() => {
        if (typeof window === 'undefined') return;

        cardsRef.current.forEach((card, index) => {
            if (!card) return;

            const direction = index % 2 === 0 ? -100 : 100;
            gsap.fromTo(
                card,
                { opacity: 0, x: direction },
                {
                    opacity: 1,
                    x: 0,
                    duration: 1,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: card,
                        start: "top 80%",
                        toggleActions: "play none none none",
                    }
                }
            );
        });
    }, []);
    
   

    return (
        <div className='w-full flex items-center justify-center pt-[80px] pb-[120px] overflow-x-hidden'>
            <div className='w-[95%] flex flex-col items-center justify-center gap-[80px]'>

                {/* ----------------------------------------------------------------- Provided Our Services Header With Background Image and Gradient layer --------------------------------------------------------------------------------- */}

                <div className='relative w-full flex items-center justify-center bg-technologyBg bg-cover bg-center bg-no-repeat lg:rounded-[110px] sm:rounded-[67px] xs:rounded-[50px] 1400:py-[80px] lg:py-[50px] sm:py-[40px] xs:py-[20px]'>
                    {/* <div className="absolute bg-inner inset-0 bg-gradient-to-r from-[#1FA2FF] from-[0%] via-25% to-[#A6FFCB] to-[70%] opacity-20 lg:rounded-[110px] sm:rounded-[67px] xs:rounded-[50px]"></div> */}
                    <div className='lg:w-[calc(100%-220px)] md:w-[calc(100%-100px)] sm:w-[calc(100%-60px)] xs:w-[calc(100%-20px)] flex flex-col gap-[10px] text-center font-faustina  text-[#EEEEEE]'>
                        <p className='font-bold md:text-[50px] xs:text-[32px]'>Our Services</p>
                        <p className='font-medium md:text-[24px] xs:text-[18px]'>At Param Group of Companies, we deliver tailored technology solutions that align with your business goals. Our team combines technical depth with creative execution to provide end-to-end services across multiple industries.</p>
                    </div>
                </div>

                {/* ----------------------------------------------------------------- Provided Our Services Header With Background Image and Gradient layer --------------------------------------------------------------------------------- */}

                
                {/* ------------------------------------------------------------------ Map Function for Services Cards -------------------------------------------------------------------------------------- */}
              
                <div className='grid 800:grid-cols-2 xs:grid-cols-1 lg:gap-x-[88px] flex-grow md:gap-x-[50px] gap-y-[48px]'>
                    {ServicesCards?.map((service, i) => (
                        <div
                            key={i}
                            ref={el => cardsRef.current[i] = el}
                            className="flex flex-col h-full"
                        >
                            <ProvidedService
                                title={service.title}
                                description={service.description}
                            />
                        </div>
                    ))}
                </div>

                {/* ------------------------------------------------------------------ Map Function for Services Cards -------------------------------------------------------------------------------------- */}
            </div>
        </div>
    )
}

export default ProvidedServices